export default "__VITE_ASSET__Iy3FghRO__"